import Text from '/src/components/@common.blocks/Text'

const ActiveFilter = ({ id, name, value, onClear }) => {
  return (
    <div className='active-filter'>
      {name && (
        <Text
          color='light-gray'
          component='span'
          weight='medium'
          className='text-capitalize active-filter__name'
        >
          {`${name}:`}
        </Text>
      )}
      <Text component='span' weight='medium'>
        {value}
      </Text>
      <div
        className='active-filter__clear'
        onClick={(e) => onClear(e, id, value)}
      >
        <div>
          <div />
          <div />
        </div>
      </div>
    </div>
  )
}

export default ActiveFilter
